"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const react_1 = __importDefault(require("react"));
exports.default = _ref => {
  let width = _ref.width,
    height = _ref.height;
  return react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 12 12"
  }, react_1.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, react_1.default.createElement("path", {
    fill: "#FFD93B",
    d: "M3.525 9.013A5.487 5.487 0 0 0 7.728 0a6.145 6.145 0 0 1-1.88 11.993A6.145 6.145 0 0 1 0 7.728a5.463 5.463 0 0 0 3.525 1.285z"
  }), react_1.default.createElement("path", {
    fill: "#F4C534",
    d: "M9.646 1.027a6.107 6.107 0 0 1 1.316 3.79 6.144 6.144 0 0 1-6.144 6.144 6.107 6.107 0 0 1-3.791-1.315 6.124 6.124 0 0 0 4.822 2.347 6.144 6.144 0 0 0 6.144-6.144c0-1.958-.92-3.698-2.347-4.822z"
  }), react_1.default.createElement("g", {
    fill: "#FFD83B"
  }, react_1.default.createElement("path", {
    d: "M3.075 2.399l.633 1.283 1.415.205-1.024.998.242 1.41-1.266-.665-1.266.665.242-1.41-1.025-.998 1.416-.205zM6.645 1.988l.328.665.733.107-.53.517.125.73-.656-.344-.657.345.126-.73-.531-.518.734-.107z"
  }))));
};